import { render, staticRenderFns } from "./pratica.vue?vue&type=template&id=68656daa"
import script from "./pratica.vue?vue&type=script&lang=js"
export * from "./pratica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports